import React, { useState, useEffect, useContext, useRef } from 'react';
import './Weather.css';
import { format } from 'date-fns';
import { enUS } from 'date-fns/locale'
import WeatherIcon from '../WeatherIcon/WeatherIcon';
import convenienceApi from '../../common/api/convenience';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function Weather() {
  const environmentContext = useContext(EnvironmentContext);
  const [weather, setWeather] = useState(null);
  const [weatherError, setWeatherError] = useState(false);
  const [updateTimeInterval, setUpdateTimeInterval] = useState(null);
  const [updateWeatherInterval, setUpdateWeatherInterval] = useState(null);
  const [formattedDisplayTime, setFormattedDisplayTime] = useState(null);
  const { activeUser: user, selectedMonitoredIndividual, hasToken, organization } = environmentContext;
  const isLoading = useRef(false);

  if (logComponent('Weather')) { console.debug('Weather rendered'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('Weather')) { console.debug('Weather onMount'); }
    if (!hasToken) return;
    return () => {
      if (updateTimeInterval) clearInterval(updateTimeInterval);
      if (updateWeatherInterval) clearInterval(updateWeatherInterval);
    };

  }, [])


  useEffect(() => {
    if (logComponent('Weather')) { console.debug('Weather useEffect  [environmentContext.hasToken, environmentContext.activeUser]'); }
    if (!hasToken) return;
  
    loadCurrentWeather();
  }, [environmentContext.hasToken, environmentContext.activeUser])

  useEffect(() => {
    if (logComponent('Weather')) { console.debug('Weather useEffect  [environmentContext.selectedMonitoredIndividual]'); }
    if (!hasToken) return;

    if (user.groupTypeString === 'Family') {
      loadCurrentWeather();
    }
  }, [environmentContext.selectedMonitoredIndividual])


  const loadCurrentWeather = () => {
    if (logComponent('Weather')) { console.debug('Weather loadCurrentWeather'); }

    if (!hasToken || isLoading.current) return;
    isLoading.current = true;
    setWeatherError(false);

    convenienceApi.getWeather(user, selectedMonitoredIndividual)
      .then(
        weather => {
          setWeather(weather);
          setWeatherError(false);
          setUpdateTimeInterval(setInterval(() => { updateTime() }, 30000));
          setUpdateWeatherInterval(setInterval(() => { loadCurrentWeather() }, 1800000));
          updateTime();
          isLoading.current = false;
        },
        error => {
          setWeatherError(true);
          isLoading.current = false;
        }
      )
  }

  const updateTime = () => {
    if (logComponent('Weather')) { console.debug('Weather updateTime'); }
    if (!hasToken) return;

    let newFormattedDisplayTime = format(new Date(), 'h:mm aaa', {
      locale: enUS
    })
    setFormattedDisplayTime(newFormattedDisplayTime);
  }


  return (
    <div className="Weather">
      {
        weather && formattedDisplayTime &&
        <a
          tabIndex="-1"
          className="Weather__body"
          href={`https://openweathermap.org/find?q=${weather.postalCode}`}
          title="Click to visit OpenWeather"
          target="_blank" rel="noopener noreferrer">
          <div className="Weather__section-1">
            <div className="Weather__temperature">
              <span className="Weather__temperature-number">{Math.round(weather.temperature)}</span>
              <span className="Weather__temperature-other">
                <span className="Weather__temperature-degree-symbol">{'\u00B0'}</span>
                <span className="Weather__temperature-scale">F</span>
              </span>
            </div>
            <div className="Weather__icon">
              <WeatherIcon icon={weather.icon} />
            </div>
          </div>
          <div className="Weather__section-2">
            <p className="Weather__city">{weather.cityName}</p>
            <p className="Weather__time">{formattedDisplayTime}</p>
            <p className="Weather__attribution">powered by OpenWeather</p>
          </div>
        </a>
      }
      {
        weatherError &&
        <p className="Weather__error">
          Weather failed to load...
        </p>
      }
    </div>
  );
}